export let accounts = {
  paging: {
    count: 10,
    currentPage: 1,
    total: 3,
    totalPages: 1,
  },
  content: [
    {
      accountId: 'account_01',
      accountName: 'Account 01',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      ownerId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
      stripeAccountId: 'stripe_account_01',
      status: 'ACTIVE',
      stripeStatus: 'ACTIVE',
      enabled: true,
      poolAccount: false,
      authorizedUsers: ['e8bf202c-3ed1-4c4d-b038-9055ad8711ef'],
      storeIds: [
        'a8bd1f53-6172-4f1f-b78b-50c7cf052151',
        '06f89534-d4f2-4efe-823b-b8fa74bbc6c5',
      ],
    },
    {
      accountId: 'account_02',
      accountName: 'Account 02',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      ownerId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
      stripeAccountId: 'stripe_account_02',
      status: 'PENDING',
      stripeStatus: 'PENDING',
      enabled: true,
      poolAccount: true,
      authorizedUsers: [],
      storeIds: [],
    },
    {
      accountId: 'account_03',
      accountName: 'Account 03',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      ownerId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
      stripeAccountId: 'stripe_account_03',
      status: 'PENDING',
      stripeStatus: 'PENDING',
      enabled: true,
      poolAccount: false,
      authorizedUsers: [],
      storeIds: [],
    },
  ],
};
